// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import image from './image'
import settingSlice from "./setting";
import deploymentReducer from "./deploymentSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    image: image,
    setting: settingSlice,
    deployment: deploymentReducer,
  },
});

export default store;
